<template>
  <div class="evaluating">
    <!-- <bannerof
      v-if="navlist !== null && navlist.length > 0"
      style="color: #ffffff"
      :Imgsrc="childrendata[0].bannerUrl"
    ></bannerof> -->
    <secondary-banner title="职业测评"></secondary-banner>
    <div class="eval_warp secondary_page_bg">
      <div class="inner eval_centers">
        <div class="elval_left">
          <h2 class="elvaltitH1">职业测评</h2>
          <div class="elval_types">
            <div class="elvaltype_list">
              <span
                class="eltyspan"
                :class="queryParams.type == null ? 'selstyle' : ''"
                @click="selbtns(0)"
                >全部</span
              >
              <span
                v-for="(item, index) in careeTypeList"
                :key="index"
                @click="selbtns(item)"
                class="eltyspan"
                :class="queryParams.type == item.dictValue ? 'selstyle' : ''"
                >{{ item.dictLabel }}</span
              >
            </div>
            <!-- 搜索 -->
            <!-- <div class="search_inp">
              <el-input
                placeholder="请输入标题"
                v-model="queryParams.title"
                clearable
                @keyup.enter.native="searchBtns"
                class="input-with-select"
                @clear="searchBtns"
              >
                <i
                  slot="suffix"
                  @click="searchBtns"
                  class="el-input__icon el-icon-search"
                ></i>
              </el-input>
            </div> -->
          </div>
          <div class="elvalistop" v-if="careerQuizList == null">
            <el-empty description="加载中..."></el-empty>
          </div>
          <div class="elvalistop" v-else-if="careerQuizList.length == 0">
            <el-empty description="空空如也"></el-empty>
          </div>
          <div v-else class="elvalistop" v-loading="cploading">
            <div
              class="elval_opcenter"
              v-for="(item, index) in careerQuizList"
              :key="index"
            >
              <div class="eval_titop1">
                <p class="titelval">
                  {{ item.title }}
                </p>
              </div>
              <div class="eval_titop2">
                <p class="jianjie" v-if="item.introduction == null"></p>
                <div v-else class="jianjie">
                  <p
                    @click="detailRouer(item)"
                    class="txtfuweb"
                    v-html="item.introduction.replace(/src/g, ' ')"
                  ></p>
                  <div class="pjlistops">
                    <div class="pjitems">
                      <img class="pjicons" src="../../assets/images/smile.png" mode="" />
                      <span class="pjtxt">很准 {{ item.evaluate.accurate }}人</span>
                    </div>
                    <div class="pjitems">
                      <img class="pjicons" src="../../assets/images/kind.png" mode="" />
                      <span class="pjtxt">一般 {{ item.evaluate.generally }}人</span>
                    </div>
                    <div class="pjitems">
                      <img class="pjicons" src="../../assets/images/sad.png" mode="" />
                      <span class="pjtxt">不准 {{ item.evaluate.inaccurate }}人</span>
                    </div>
                  </div>
                </div>
                <div class="jianj_rights">
                  <span v-if="mycepIdAll == null"></span>
                  <span v-else-if="mycepIdAll.indexOf(item.id) > -1" class="yescep"
                    >再次测评</span
                  >
                  <span v-else class="nocep">未测评</span>
                  <span v-if="mycepIdAll == null"></span>
                  <span
                    v-else-if="mycepIdAll.indexOf(item.id) > -1"
                    class="start_cp cpbaogao"
                    @click="detailRouer(item, 1)"
                    >查看结果</span
                  >
                  <span v-else class="start_cp" @click="detailRouer(item)">开始测评</span>
                </div>
              </div>
            </div>
          </div>
          <div class="page_pl">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="queryParams.pageNum"
              :page-size="queryParams.pageSize"
              background
              layout="total,prev, pager, next"
              :total="total"
              hide-on-single-page
            >
            </el-pagination>
          </div>
        </div>
        <div class="elva_right">
          <div class="elva_rigtit">
            <p class="rig_qiu"></p>
            <h3>我的测评</h3>
          </div>
          <div class="elvalistop" v-if="mequizlist == null">
            <el-empty description="加载中..."></el-empty>
          </div>
          <div v-else-if="mequizlist.length == 0">
            <el-empty description="空空如也"></el-empty>
          </div>
          <div class="elvarig_center" v-else>
            <el-scrollbar style="height: 100%">
              <div v-for="(item, index) in mequizlist" :key="index" class="elvrlistv">
                <div class="elvrig_left">
                  <el-tooltip
                    :content="item.title"
                    placement="top"
                    effect="light"
                    v-if="item.title.length > 12"
                  >
                    <p class="elvrigcen_tit">{{ item.title }}</p>
                  </el-tooltip>
                  <p v-else class="elvrigcen_tit">{{ item.title }}</p>

                  <p class="jianjie" v-if="item.introduction == null"></p>
                  <div v-else>
                    <p
                      class="jianjie"
                      v-html="item.introduction.replace(/src/g, ' ')"
                    ></p>
                  </div>
                </div>
                <div class="elvr_rigs" @click="detailRouer(item, 1)">
                  <img src="@/assets/images/resultRg.png" alt="" />
                  <span>查看结果</span>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { listCareerQuiz, CareerQuizType, MecareerQuiz } from "@/api/evaluating";
import bannerof from "@/components/bannerof";
import SecondaryBanner from "@/components/SecondaryBanner";
export default {
  name: "evaluating",
  data() {
    return {
      navId: null,
      childtype: null,
      navlist: null,
      childrendata: null,
      bannerData: {
        title: "",
        subtit: "",
      },
      careerQuizList: null,
      careeTypeList: [],
      searchval: "",
      selstatus: "",
      queryParams: {
        title: "",
        type: null,
        pageNum: 1,
        pageSize: 6,
      },
      mequizlist: null,
      mycepIdAll: null,
      total: 0,
      cploading: false,
    };
  },
  components: {
    bannerof,
    SecondaryBanner,
  },
  watch: {
    "$store.state.user.navbarList": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (newValue.length > 0) {
          console.log("1");
          this.$nextTick(() => {
            this.navforEcher();
          });
        }
      },
    },
    "$route.query": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (!newValue.childtype) {
          this.childtype = null;
        } else {
          this.childtype = newValue.childtype;
        }

        this.$nextTick(() => {
          console.log("4");
          this.navforEcher();
        });
      },
    },
  },
  created() {
    this.navId = this.$route.query.navId;
    if (this.$route.query.childtype) {
      this.childtype = this.$route.query.childtype;
    } else {
      this.childtype = null;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.navforEcher();
      this.getcareeList();
      this.typeListall();
      this.getmeEval();
    });
  },
  methods: {
    navforEcher() {
      var navlistall = JSON.parse(JSON.stringify(this.$store.state.user.navbarList));
      //筛选出来当前tab栏
      this.navlist = navlistall.filter((el) => {
        return this.navId == el.id;
      });
      if (navlistall.length > 0) {
        //给tab底部高亮
        this.$store.commit("user/SET_TABINDEX", this.childtype);
        if (this.childtype !== null) {
          this.childrendata = this.navlist[0].children.filter((el) => {
            return this.childtype == el.id;
          });
        }
      }
      //测评列表
    },
    /** 查询职业测评列表 */
    getcareeList() {
      this.cploading = true;
      listCareerQuiz(this.queryParams).then((response) => {
        this.careerQuizList = response.rows;
        this.total = response.total;
        this.cploading = false;
      });
    },
    //查询类型
    typeListall() {
      CareerQuizType().then((response) => {
        this.careeTypeList = response.data;
      });
    },
    //搜索
    searchBtns() {
      this.getcareeList();
    },
    //筛选
    selbtns(item) {
      if (item == 0) {
        this.queryParams.type = null;
      } else {
        this.queryParams.type = item.dictValue;
      }
      this.getcareeList();
    },
    //查询我的测评
    getmeEval() {
      MecareerQuiz().then((response) => {
        this.mequizlist = response.rows;
        this.mycepIdAll = [];
        if (this.mequizlist.length > 0) {
          for (let i = 0; i < this.mequizlist.length; i++) {
            this.mycepIdAll.push(this.mequizlist[i].id);
          }
        }
      });
    },
    //详情内容
    detailRouer(item, mydeta) {
      var indresult;
      if (this.mycepIdAll.indexOf(item.id) > -1) {
        indresult = 1;
      } else {
        indresult = 0;
      }
      let rourl;
      if (mydeta == 0 || mydeta == 1) {
        rourl = this.$router.resolve({
          path: "/evaluaDetail",
          query: {
            id: item.id,
            mydeta: mydeta,
            tabindex: this.$store.state.user.tabindex,
            indresult: indresult,
          },
        });
      } else {
        rourl = this.$router.resolve({
          path: "/evaluaDetail",
          query: {
            id: item.id,
            tabindex: this.$store.state.user.tabindex,
            indresult: indresult,
          },
        });
      }
      window.open(rourl.href);
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getcareeList();
      this.toTop();
    },
    toTop() {
      document.documentElement.scrollTop = 450;
    },
  },
};
</script>
<style lang="scss" scoped>
.evaluating {
  width: 100%;
  .eval_warp {
    width: 100%;

    overflow: hidden;
    .eval_centers {
      margin-top: 50px;
      margin-bottom: 35px;
      overflow: hidden;
      // 左侧
      .elval_left {
        width: 67%;
        min-height: 1050px;
        padding: 15px 20px;
        float: left;
        background-color: #fff;
        .elvaltitH1 {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
        .elval_types {
          overflow: hidden;
          .elvalopus {
            float: left;
            margin-top: 20px;
            .elvseach_tits {
              font-size: 16px;
              color: #333333;
            }
          }
          .selstyle {
            background-color: #1d4434;
            color: #ffffff !important;
          }
          // 类型list
          #nav {
            overflow-x: auto;
            overflow-y: hidden;
            &::-webkit-scrollbar {
              width: 0;
              height: 0;
            }
          }
          .elvaltype_list {
            margin-top: 19px;
            float: left;

            .eltyspan {
              display: inline-block;
              padding: 5px 17px;
              margin: 5px;
              border-radius: 18px;
              text-align: center;
              font-size: 14px;
              color: #666666;
              user-select: none;
              cursor: pointer;
              border: 1px solid #1d4434;
            }
          }
          // 搜索
          .search_inp {
            float: right;
            margin-top: 12px;
            border-radius: 20px;
            /*搜索input框 */
            ::v-deep .el-input__inner {
              border-radius: 20px !important;
            }
            i {
              font-size: 20px;
            }
          }
        }
        .elvalistop {
          .elval_opcenter {
            width: 100%;
            height: 160px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            border-radius: 4px;
            margin-top: 20px;
            overflow: hidden;
            .eval_titop1 {
              width: 100%;
              height: 46px;
              line-height: 46px;
              padding: 0 20px;
              background: #1d4434;
              border-radius: 4px 4px 0px 0px;
              color: #ffffff;
              .titelval {
                width: 100%;
                font-size: 18px;
                font-weight: 500;
                color: #ffffff;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .eval_titop2 {
              overflow: hidden;

              .jianjie {
                width: 80%;
                padding: 15px;
                line-height: 1.5;
                letter-spacing: 1px;
                float: left;
                .txtfuweb {
                  word-break: break-all;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  font-size: 15px;
                  color: #555555;
                }
              }
              .pjlistops {
                width: 60%;
                margin-top: 15px;
                display: flex;
                justify-content: space-between;

                .pjitems {
                  display: flex;
                  .pjicons {
                    width: 26px;
                    height: 26px;

                    vertical-align: middle;
                  }
                  .pjtxt {
                    line-height: 25px;
                    margin-left: 10px;
                    font-size: 14px;
                    white-space: nowrap;
                  }
                }
              }
              .jianj_rights {
                width: 148px;
                height: 95px;
                border-left: 1px solid #eeeeee;
                float: right;
                margin-top: 9px;
                text-align: center;
                overflow: hidden;
                .nocep {
                  display: inline-block;
                  font-size: 16px;
                  font-weight: 500;
                  color: #d81e06;
                  margin-top: 8px;
                }
                .yescep {
                  display: inline-block;
                  font-size: 16px;
                  font-weight: 500;
                  color: #1d4434;
                  margin-top: 8px;
                }
                // 开始/查看测评
                .start_cp {
                  display: block;
                  width: 100px;
                  height: 32px;
                  line-height: 30px;
                  margin: 0 auto;
                  margin-top: 25px;
                  color: #1d4434;
                  border: 1px solid #1d4434;
                  border-radius: 16px;
                  text-align: center;
                  cursor: pointer;
                  font-size: 15px;
                }
                .cpbaogao {
                  background: #1d4434;
                  color: #ffffff;
                }
              }
            }
          }
        }
        // 分页
        .page_pl {
          margin: 30px 0;
          text-align: center;
        }
      }
      // 右侧
      .elva_right {
        width: 30%;
        height: 1050px;
        float: right;
        padding: 15px 30px;
        letter-spacing: 1px;
        background-color: #fff;
        .elva_rigtit {
          display: flex;
          .rig_qiu {
            width: 15px;
            height: 15px;
            border: 2px solid #333333;
            border-radius: 50%;
            margin-top: 5px;
          }
          h3 {
            font-size: 18px;
            font-weight: bold;
            margin-left: 10px;
            color: #333333;
            letter-spacing: 1px;
          }
        }
        // 内容
        .elvarig_center {
          padding: 10px 0;
          ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
          }
          .elvrlistv {
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            border-bottom: 1px solid #eeeeee;
            overflow: hidden;
            .elvrig_left {
              width: 70%;

              .elvrigcen_tit {
                margin: 15px 0;
                color: #333333;
                font-size: 16px;
                font-weight: bold;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .jianjie {
                color: #555555;
                font-size: 14px;
                font-weight: 500;
                word-break: break-all;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
            }
            .elvr_rigs {
              width: 24%;
              margin-top: 6px;
              text-align: center;
              overflow: hidden;
              cursor: pointer;
              img {
                width: 34px;
                height: 40px;
                margin: 8px auto;
              }
              span {
                font-size: 14px;
                font-weight: bold;
                color: #1d4434;
              }
            }
          }
        }
      }
    }
  }
}
</style>
